export default [
  {
    name: 'getSysPermission',
    method: 'GET',
    path: '/vue/auth/permission-get'
  },
  {
    name: 'getPermissionTree',
    method: 'GET',
    path: '/vue/auth/permission-getPermissionTree'
  },
  {
    name: 'getSysPermissionList',
    method: 'POST',
    path: '/vue/auth/permission-page'
  },
  {
    name: 'saveSysPermission',
    method: 'POST',
    path: '/vue/auth/permission-save'
  },
  {
    name: 'deleteSysPermission',
    method: 'POST',
    path: '/vue/auth/permission-delete'
  },
  {
    name: 'initPermission',
    method: 'GET',
    path: '/vue/auth/permission-getByParentId'
  },
  {
    name: 'loadPermission',
    method: 'GET',
    path: '/vue/auth/permission-getByParentId'
  },
  {
    name: 'searchPermission',
    method: 'POST',
    path: '/vue/auth/permission-findList'
  }
];
